<template>
  <div class="d-flex justify-center align-center" style="height: 100vh">
    <div class="container text-center py-5">
      <img
        class="brand"
        src="/images/ocularlogo.svg"
        style="width: 200px; height: 75.41px"
      >
      <br>
      <h2 class="py-5">
        {{$t('maintenance.text')}}
      </h2>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Maintenance extends Vue {}
</script>
